<template lang="html">
  <transition name="fade" enter-active-class="fadeInDown"  mode="out-in">
    <section class="wcc section email" v-if="calculatorData.emailShow">
      <div class="wcc section-content">
        <transition name="fade" mode="out-in">
          <Auth v-if="!$store.state.auth.sessionData"></Auth>
          <VerifyEmail v-else-if="$store.state.auth.userData && !$store.state.auth.userData.emailVerified"></VerifyEmail>
          <Form v-else-if="!calculatorData.emailSent" :calculatorData="calculatorData"></Form>
          <Confirmation v-else ></Confirmation>
        </transition>
      </div>
    </section>
  </transition>
</template>
<script>
  import Auth from '@/components/Auth/_auth.vue'
  import VerifyEmail from '@/components/Auth/_verifyEmail.vue'
  import Form from '@/components/Email/_form.vue'
  import Confirmation from '@/components/Email/_confirmation.vue'

  export default {
    props: ['calculatorData'],
    components: {
      Auth,
      VerifyEmail,
      Form,
      Confirmation
    }
  }
</script>
<style lang="scss">
  .wcc.section.email {
    background-color: white;
    .wcc.section-content {
      margin: $spacing;
      h2 {
        margin-top: 0;
      }
    }
  }
</style>